// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NorstellaCoverageFinder styles */

:host {
  all: initial;
}

.norstella-cf-coverageFinder {
  text-align: left;
}

.norstella-cf-loaderTable {
  position: absolute;
  z-index: 3;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 60px;
  height: 60px;
}

.norstella-cf-MuiInputBase-input {
  height: 0.9175em;
}

.norstella-cf-searchButton {
  border-radius: 6px;
  padding: 8px 16px;
  text-transform: capitalize;
  height: 40px;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  align-self: end;
  /* 24px */
}

.norstella-cf-MuiButton-startIcon {
  margin-right: 0px;
}

.norstella-cf-coverageFinderBox {
  display: flex;
  flex-wrap: wrap;
  padding: max(10px, 1vw);
  color: #000;
}

.norstella-cf-flexAlignCenterRow {
  display: flex;
  align-items: center;
  flex-direction: row;
}

.norstella-cf-flexAlignStartRow {
  display: flex;
  align-items: start;
  flex-direction: row;
}

.norstella-cf-prescriberCustomNoteDialog {
  display: flex;
  flex-direction: column;
  margin: 10px;
}

.norstella-cf-paFormDialog {
  display: flex;
  flex-direction: column;
  margin: 10px;
}

.norstella-cf-popupPAForm {
  width: 250px;
}

.norstella-cf-paFormOkBtn {
  width: 50px;
  margin-top: 10px;
}

.norstella-cf-div-row {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.norstella-cf-div-col {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.norstella-cf-searchLabel {
  width: 100%;
}

.norstella-cf-lblLocation {
  font-weight: bold;
  padding-bottom: 3px;
}

.norstella-cf-lblIndication {
  font-weight: bold;
  padding-bottom: 3px;
}

.norstella-cf-indicationDiv {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.norstella-cf-indicationDDLDiv {
  width: 100%;
}


.norstella-cf-lblProduct {
  font-weight: bold;
  padding-bottom: 3px;
}

.norstella-cf-productDiv {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.norstella-cf-productDDLDiv {
  width: 100%;
}

.norstella-cf-lblNPI {
  font-weight: bold;
  padding-bottom: 3px;
}

.norstella-cf-lblFilterCriteria {
  font-weight: bold;
  padding-bottom: 3px;
}

.norstella-cf-filterdiv {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.norstella-cf-header {
  font-family: "Poppins Bold", Arial, Helvetica, sans-serif;
}

.norstella-cf-SortIcon {
  height: 20px;
  width: 20px;
  margin-left: 5px;
}

/* Desktop Only Styles */
@media screen and (min-width: 1033px) {
  .norstella-cf-benefitTypeButtonGroup {
    width: 200px;
  }

  .norstella-cf-searchComponents {
    flex-direction: row;
    align-items: center;
    position: relative;
  }

  .norstella-cf-message {
    margin-top: 0px;
    position: absolute;
    left: "0";
    top: 100%;
    margin-left: 0px;
  }

  .norstella-cf-productDDLDiv {
    position: relative;
  }

  .norstella-cf-productDDLDiv .norstella-cf-message {
    top: 40px;
  }

  .norstella-cf-noPlanCardMessage {
    margin-top: 20px;
    position: relative;
    width: 100%;
    margin-left: 50%;
    color: red;
  }

  .norstella-cf-searchButton {
    margin-left: 7px;
    text-transform: capitalize;
  }

  .norstella-cf-patientsearchButton {
    border-radius: 6px;
    padding: 8px 16px;
    height: 40px;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
    align-self: end;
    margin-left: 25px;
    text-transform: capitalize;
  }

  .norstella-cf-PatientGridContainerSubHeaderDualBenefit {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .norstella-cf-PatientGridItemSubHeader {
    flex-grow: 1;
  }

  .norstella-cf-PatientGridItemDualBenefit {
    margin-left: auto;
  }

  .norstella-cf-divSearchCoverage {
    width: 50%;
  }

  .norstella-cf-flexAlignResponsive {
    display: flex;
    align-items: center;
    flex-direction: row;
  }

  .norstella-cf-flexAlignFilterBar {
    display: flex;
    align-items: end;
    flex-direction: row;
    justify-content: space-between;
    padding-left: 16px;
    padding-right: 16px;
  }

  .norstella-cf-leftMargin {
    margin-left: 25px;
  }

  .norstella-cf-bottomMargin {
    margin-bottom: 0px;
  }

  .norstella-cf-rightMargin {
    margin-right: 10px;
  }

  .norstella-cf-MuiAutocomplete-root {
    width: 300px;
    min-width: 200px;
  }

  .norstella-cf-searchText {
    min-width: 200px;
  }

  .norstella-cf-searchComponents .norstella-cf-MuiAutocomplete-option.Mui-focused {
    font-weight: bold;
    background-color: #949494;
  }

  .norstella-cf-MuiAutocomplete-root .norstella-cf-MuiOutlinedInput-root .norstella-cf-MuiAutocomplete-input::placeholder {
    color: #595959 !important;
    opacity: 1 !important;
  }

  .norstella-cf-MuiInputBase-input::placeholder {
    color: #595959 !important;
    opacity: 1 !important;
  }

  .norstella-cf-ProductText {
    min-width: 200px;
  }

  .norstella-cf-npiSearch {
    min-width: 170px;
  }

  .norstella-cf-npierrormessage {
    min-width: 170px;
  }

  .norstella-cf-filtererrormessage {
    min-width: 170px;
    margin-left: 30px;
  }

  .norstella-cf-searchPlans {
    width: 30%;
    min-width: 150px;
    margin-right: 2px;
    height: 42px;
    min-height: 42px;
  }

  /* .norstella-cf-divSearchResults {
    width: 30%;
    display: inline-grid;
  } */

  .norstella-cf-header {
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
  }

  .norstella-cf-MuiToggleButtonGroup-grouped {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 8px;
    padding-right: 8px;
    line-height: 20px;
  }

  .norstella-cf-notedetails {
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 130%;
    text-align: center;
  }

  .norstella-cf-statement {
    font-weight: bold;
    white-space: initial;
  }

  .norstella-cf-MuiGrid-root.norstella-cf-MuiGrid-item.statementDualBenefitMuiGridItem {
    padding-top: 0px;
  }

  .norstella-cf-headerSubHeader {
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 130%;
    white-space: initial;
    margin-top: 7px;
  }

  .norstella-cf-hidden {
    visibility: hidden;
  }

  .norstella-cf-geoSearchHidden {
    height: 20px;
    min-width: 200px;
  }

  .norstella-cf-coverage-content {
    border-bottom: 4px solid #000;
  }

  .norstella-cf-prescriberNoteHeader {
    padding-left: 16px;
    padding-right: 16px;
  }

  .norstella-cf-filterdiv {
    margin-left: 20px;
  }

  .norstella-cf-MuiAutocomplete-root .norstella-cf-MuiOutlinedInput-root .norstella-cf-MuiAutocomplete-input {
    padding: 3px 4px 3px 5px;
  }
}

@media screen and (min-width: 1185px) {
  .norstella-cf-searchPlans {
    width: 100%;
  }
}

/* Mobile Styles */
@media screen and (max-width: 1032px) {
  .norstella-cf-PatientGridContainerSubHeaderDualBenefit {
    flex-direction: column;
  }

  .norstella-cf-PatientGridItemDualBenefit {
    margin-left: 0;
  }

  .norstella-cf-searchComponents {
    flex-direction: column;
    align-items: flex-start;
    position: relative;
  }

  .norstella-cf-message {
    margin-top: 5px;
    position: static;
    left: "0";
    top: 100%;
    margin-left: 0px;
  }

  .norstella-npi-message {
    margin-left: 55%;
  }

  .norstella-cf-noPlanCardMessage {
    margin-top: 20px;
    position: relative;
    width: 100%;
    margin-left: 35%;
    color: red;
  }

  .norstella-cf-searchButton {
    margin-left: 0px;
    margin-top: 15px;
    margin-bottom: 20px;
    width: 98%;
    text-transform: capitalize;
  }

  .norstella-cf-patientsearchButton {
    margin-top: 10px;
    width: 94%;
    text-transform: capitalize;
  }

  .norstella-cf-sortButton {
    text-transform: capitalize;
    background-color: rgb(0, 88, 111);
    margin-right: 7px;
    height: 44px;
    padding: 0px;
  }

  .norstella-cf-searchContainer {
    display: flex;
    gap: 10px;
    width: 100%;
  }

  .norstella-cf-sortButton:hover {
    background-color: rgb(0, 88, 111);
  }

  .norstella-cf-sortCard {
    border: none;
  }

  /* Target odd cards */
  .norstella-cf-mobileCardView .norstella-cf-card:nth-child(odd) {
    background-color: #ffffff;
  }

  /* Target even cards */
  .norstella-cf-mobileCardView .norstella-cf-card:nth-child(even) {
    background-color: #eff6f9;
  }

  .norstella-cf-divSearchCoverage {
    width: 100%;
  }

  .norstella-cf-filterdiv {
    width: 100%;
  }

  .norstella-cf-flexAlignResponsive {
    display: flex;
    align-items: space-between;
    flex-direction: column;
  }

  .norstella-cf-leftMargin {
    margin-left: 0px;
  }

  .norstella-cf-bottomMargin {
    margin-bottom: 10px;
  }

  .norstella-cf-rightMargin {
    margin-right: 0px;
  }

  .norstella-cf-channelDiv {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
  }

  .norstella-cf-MuiAutocomplete-root {
    width: 98%;
    height: 44px;
  }

  .norstella-cf-MuiInputBase-root {
    height: 44px;
  }

  .norstella-cf-channelLabel {
    font-weight: bold;
    padding-bottom: 3px;
    display: flex;
    justify-content: left;
  }

  .norstella-cf-searchPlans {
    display: flex;
    align-items: center;
    flex-grow: 1;
  }

  .norstella-cf-searchPlansInput {
    width: 100%;
  }

  .norstella-cf-MuiGrid-root.norstella-cf-MuiGrid-item {
    padding-top: 0px;
  }

  .norstella-cf-MuiGrid-root.norstella-cf-MuiGrid-item.header {
    font-size: larger;
    font-weight: bold;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .norstella-cf-coverage-content {
    margin-top: 20px;
    border-top: 1px solid #000;
    border-top-width: thick;
    padding-top: 10px;
  }

  .norstella-cf-notedetails {
    font-size: 10px;
    font-style: normal;
    font-weight: 700;
    line-height: 130%;
  }

  .norstella-cf-coverageFilterAndTable {
    margin-left: 4%;
  }

  .norstella-cf-header {
    line-height: 120%;
    white-space: initial;
    margin-top: 20px;
    margin-bottom: 11px;
  }

  .norstella-cf-headerSubHeader {
    font-weight: bold;
    white-space: initial;
    margin-top: 7px;
    margin-bottom: 11px;
  }

  #geoSearch {
    min-height: 0;
  }

  #npiSearch {
    min-height: 0;
  }

  .norstella-cf-prescriberNoteHeader {
    padding-left: 16px;
    padding-right: 16px;
  }

  .norstella-cf-footer {
    margin-top: 10px;
  }

  .norstella-cf-verticalNoteValue {
    display: inline;
    margin-left: 3px;
  }

  .norstella-cf-divPAFormDialogOuter {
    display: inline;
  }

  .norstella-cf-sectionFieldDash {
    margin-left: 5px;
  }

  .norstella-cf-customValue {
    display: inline;
  }

  .norstella-cf-MuiAutocomplete-root .norstella-cf-MuiOutlinedInput-root .norstella-cf-MuiAutocomplete-input {
    padding: 7.5px 4px 7.5px 5px;
  }

  .norstella-cf-MuiAutocomplete-root .norstella-cf-MuiAutocomplete-inputRoot {
    padding-top: 0px;
    padding-bottom: 0px;
  }
}

/* Media Query from 1200 to 1032 stacking search bar and buttons */
@media screen and (max-width: 1200px) {
  .norstella-cf-flexAlignFilterBar {
    display: block !important;
    text-align: center;
  }

  .norstella-cf-searchPlans {
    margin-bottom: 5px !important;
  }

  .norstella-cf-divChannelButtonGroup {
    padding-bottom: 5px;
    display: flex;
    justify-content: center;
  }

  /* Lowering percentage statement font size to fit screen width */
  .norstella-cf-dynamicStatement {
    font-size: 21px !important;
  }
}

@media (max-width: 1023px) {
  .norstella-cf-benefitTypeButtonGroup {
    width: 100%;
    display: flex;
    margin-left: 0;
    justify-content: center;
    padding-top: 3px;
  }

  .norstella-cf-benefitTypeButtonGroup button {
    width: 50%;
    flex: 1;
    border-radius: 4px;
  }

  .norstella-cf-benefitLabel {
    font-weight: bold;
    margin-left: 0;
  }

  .norstella-cf-statement {
    font-weight: bold;
    white-space: initial;
    margin-bottom: 6px;
  }
}

.norstella-cf-prescriberNoteSectionName {
  display: block;
  font-size: 1.5em;
  margin-block-start: 0.83em;
  margin-block-end: 0.83em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: bold;
}

/* Remove this if changing styles */
/* .geoSearchInput {
    padding: 0px;
} */

.norstella-cf-displayCoverageLayoutGridItem {
  padding-top: 3px;
  padding-left: 16px;
  padding-right: 16px;
}

.norstella-cf-searchSeparator {
  margin-left: 10px;
  margin-right: 10px;
}

.norstella-cf-benefitTypeDiv {
  display: flex;
  flex-direction: column;
  margin-left: auto;
  float: right;
  position: relative;
}

.norstella-cf-benefitTypeButtonGroup {
  display: flex;
  justify-content: center;
}

.norstella-cf-benefitTypeButtonGroup button {
  width: 50%;
  flex: 1;
  border-radius: 4px;
}

.norstella-cf-benefitLabel {
  font-weight: bold;
  padding-bottom: 3px;
}

.norstella-cf-benefitTypeButton {
  text-transform: capitalize;
}

.norstella-cf-message {
  color: #b50505;
}

.norstella-cf-message-error {
  color: #b50505;
}

.norstella-cf-autocomplete-custom-close {
  padding: 0px !important;
}

.norstella-cf-patientInsuranceType .norstella-cf-MuiInputBase-root {
  padding-right: 14px !important;
}

.norstella-cf-patientBenefitType .norstella-cf-MuiInputBase-root {
  padding-right: 14px !important;
}

.norstella-cf-patientGeoSearch .norstella-cf-MuiInputBase-root {
  padding-right: 14px !important;
}

#norstella-cf-geoSearch .norstella-cf-MuiAutocomplete-inputRoot {
  padding-right: 9px;
}

.norstella-cf-resultmessage {
  color: #000;
  text-align: center;
  font-weight: bold;
  margin-top: 1rem;
}

.norstella-cf-noresultmessage {
  display: flex;
  justify-content: center;
  /* Center horizontally */
  align-items: center;
  /* Center vertically */
  width: 100%;
  /* Ensure the span takes full width */
  height: 100%;
  /* Ensure the span takes full height */
  font-weight: bold;
  margin-bottom: 10px;
}

.norstella-cf-channelButtonGroup .norstella-cf-channelButton {
  text-wrap: nowrap;
  font-size: min(18px, max(14px, 0.8vw));
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  height: 42px;
  min-height: 42px;
}

.norstella-cf-MuiTouchRipple-rippleVisible {
  opacity: 0.2 !important;
}

.norstella-cf-divChannelButtonGroup {
  height: 42px;
  min-height: 42px;
}

/* Table */
.norstella-cf-MuiTable-root.norstella-cf-MuiTable-stickyHeader {
  table-layout: fixed;
}

.norstella-cf-coverageTableContainer {
  border-radius: 3px;
  overflow-y: scroll !important;
}

.norstella-cf-prescriberNoteContainer {
  border-radius: 3px;
}

.norstella-cf-tableHeaderRow {
  background-color: #bebebe;
}

#coverageTableContainer:focus-visible {
  outline: solid !important;
}

.norstella-cf-focusHeadRow .norstella-cf-focusCellData:focus-visible {
  outline: solid;
}

.norstella-cf-MuiTableSortLabel-root:hover .norstella-cf-MuiTableSortLabel-icon {
  color: #0E575D;
  opacity: 1;
}

.norstella-cf-MuiTableSortLabel-root.Mui-active .norstella-cf-MuiTableSortLabel-icon {
  color: #4F4F4F;
}

.norstella-cf-tableHeaderCell {
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  min-width: 20%;
  line-height: 20px;
  text-wrap: wrap;
  top: auto;
}

.norstella-cf-tableDataCell {
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.norstella-cf-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0 0 0 / 89%);
  /* Semi-transparent black color */
  z-index: 999;
  /* Ensure the overlay is above other content */
}

.norstella-cf-tableHeaderRow th:last-child {
  border-right: 0;
}

.norstella-cf-verticalTableContainer label {
  font-weight: bold;
}

.norstella-cf-verticalTableContainer th:last-child {
  border: 0;
}

.norstella-cf-verticalTableContainer td:last-child {
  border: 0;
}

.norstella-cf-tableHeaderCellPlanName {
  width: 50%;
  text-wrap: balance;
}

.norstella-cf-tableHeaderCellPlanNamePAR {
  text-wrap: balance;
}

.norstella-cf-tableHeaderCellPrescriberNotes {
  min-width: 150px;
}

.norstella-cf-tableSortLabel>svg {
  height: 20px;
  width: 20px;
  margin-left: 5px;
}

.norstella-cf-mobilePlanHeader {
  display: block;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%;
  margin-top: 0px;
  margin-bottom: 0px;
}

.norstella-cf-mobilePlanDetails {
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.norstella-cf-tableNotesDiv {
  width: 100%;
}

.norstella-cf-tableHeaderCellIcon {
  display: inline-block;
  vertical-align: middle;
}

.norstella-cf-tableRowCellIcon {
  display: inline-block;
  vertical-align: middle;
  font-size: 25px;
}

.norstella-cf-DynamicColCellIcon {
  display: inline-block;
  vertical-align: middle;
  height: 20px;
  width: 20px;
  cursor: pointer;
}

.norstella-cf-DynamicColCellIconBefore {
  margin-right: 5px;
}

.norstella-cf-DefaultLoadingIcon {
  display: inline-block;
  vertical-align: middle;
  height: 40px;
  width: 40px;
  cursor: pointer;
  animation: spin 1s linear infinite;
  margin: auto;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.norstella-cf-displayPrefix {
  margin-right: 5px;
}

.norstella-cf-PAFormIcon {
  display: inline-block;
  vertical-align: middle;
  height: 20px;
  width: 20px;
}

.norstella-cf-spansContainer {
  display: flex;
  flex-direction: column;
}

.norstella-cf-mobilePlanDetailsContainer {
  display: flex;
  flex-direction: column;
}

.norstella-cf-tableRowCellNoteText {
  vertical-align: 0px;
  text-decoration: underline;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: #18766d;
}

.norstella-cf-tableColHidden {
  display: none;
}

.norstella-cf-card {
  margin-top: 10px;
}

.norstella-cf-footer {
  text-align: left;
}

.norstella-cf-customFooter {
  font-size: smaller;
  margin-bottom: 15px;
}

.norstella-cf-planCardDetails {
  font-size: smaller;
  margin-bottom: 15px;
  width: 100%;
}

.norstella-cf-patientDiv {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.norstella-cf-topMargin {
  margin-top: 20px;
}

.norstella-cf-patientSearchInfoIcon {
  margin-right: 5px;
  height: 0.9em;
  font-size: 1rem;
  color: #58c3b9;
}

.norstella-cf-dynamicStatement {
  font-size: larger;
  margin-bottom: 15px;
}

.norstella-cf-headerSubHeaderText {
  font-size: larger;
  margin-bottom: 15px;
}

.norstella-cf-footerText {
  font-weight: bold;
  font-size: smaller;
}

.norstella-cf-trademark {
  margin-top: 15px;
  font-size: smaller;
}

.norstella-cf-footnoteText {
  font-size: x-small;
}

.norstella-cf-mobileCardView {
  max-height: 650px;
  overflow-y: auto;
}

.norstella-cf-mobileCardView.disable-scroll {
  overflow-y: hidden !important;
  /* Remove scrolling on mobile when popup is open */
}

.norstella-cf-MuiDataGrid-root .norstella-cf-MuiDataGrid-cell {
  white-space: normal !important;
  word-wrap: break-word !important;
}

.norstella-cf-MuiDataGrid-columnHeaderTitle {
  font-weight: bold !important;
}

.norstella-cf-MuiInputBase-input {
  padding: 13px 14px;
}

.norstella-cf-MuiNativeSelect-root {
  width: 98%;
  border-radius: 4px;
  border: 1px solid #303030;
}

.norstella-cf-MuiNativeSelect-select {
  height: 1.3em;
}

.norstella-cf-prescriberNoteCardContent {
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #303030;
}

.norstella-cf-additionalNoteDiv {
  border-top: thick solid rgb(0, 0, 0);
}

.norstella-cf-coverageTableContainer tr:nth-child(odd) {
  background-color: #ffffff;
}

/* Styles for odd rows */
.norstella-cf-coverageTableContainer tr:nth-child(even) {
  background-color: #eff6f9;
}

.norstella-cf-prescriberNoteContainer tr:nth-child(odd) {
  background-color: #ffffff;
}

/* Styles for odd rows */
.norstella-cf-prescriberNoteContainer tr:nth-child(even) {
  background-color: #eff6f9;
}

/* Styles for even rows */
.norstella-cf-verticalTableContainer tr:nth-child(even) {
  background-color: #ffffff;
}

/* Styles for odd rows */
.norstella-cf-verticalTableContainer tr:nth-child(odd) {
  background-color: #eff6f9;
}

.norstella-cf-prescriberNoteSection {
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%;
  /* 26px */
}

.norstella-cf-tableNoteBodyCell {
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  overflow-wrap: break-word;
}

.norstella-cf-verticalTableNoteCellTitle {
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  overflow-wrap: break-word;
  width: 30%;
}

.norstella-cf-noteWithoutSectionContent {
  padding-bottom: 0px;
}

.norstella-cf-verticalTableNoteCellContent {
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  overflow-wrap: break-word;
  width: 70%;
}

.norstella-cf-verticalNoteTable {
  table-layout: fixed;
}

.norstella-cf-MuiCardContent-root:empty {
  display: none;
}

.norstella-cf-MuiCard-root {
  box-shadow: none;
}

.norstella-cf-lineNoteTitle {
  font-weight: bold;
}

.norstella-cf-dataSource {
  color: red;
}

.norstella-cf-spnCustomValueDash {
  color: black;
}

.norstella-cf-notificationCard {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #0E173E;
  color: white;
  padding: 16px;
  /* Equivalent to padding: 2 */
  border-radius: 16px;
  /* Equivalent to borderRadius: 2 */
  width: 100%;
}

.norstella-cf-notificationBox {
  display: flex;
  align-items: center;
  flex-grow: 1;
}

.norstella-cf-notificationMessage {
  margin-right: 16px;
  /* Equivalent to marginRight: 2 */
}

.norstella-cf-button {
  background-color: #45D7C4;
  color: #0E173E;
  text-transform: none;
}

@media (max-width: 768px) {
  .norstella-cf-PatientColDiv {
    margin-right: 20px;
  }

}

.norstella-cf-visiblehidden-aria-label {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Disable scrolling */
.no-scroll {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
  touch-action: none;
  /* Prevents touch scrolling */
}

@media (max-width:330px) {
  .norstella-cf-displayCoverageLayoutGridItem {
    padding-left: 0px;
    margin: 0 auto;
  }

  .norstella-cf-mobileCardView::-webkit-scrollbar {
    width: 1px;
  }

  .norstella-cf-mobileCardView::-webkit-scrollbar-thumb {
    scrollbar-color: rgb(0, 0, 0, 0.2);
    border-radius: 4px;
  }

  .norstella-cf-displayCoverageCardContent {
    padding: 8px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CoverageFinder/style.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAEnC;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;;;KAGG;;EAEH;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,iCAAiC;IACjC,iBAAiB;IACjB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,aAAa;IACb,SAAS;IACT,WAAW;EACb;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,YAAY;EACd;;EAEA,qBAAqB;EACrB;IACE,yBAAyB;EAC3B;;EAEA,sBAAsB;EACtB;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,0BAA0B;IAC1B,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA,kEAAkE;AAClE;EACE;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,uBAAuB;EACzB;;EAEA,gEAAgE;EAChE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,WAAW;IACX,aAAa;IACb,cAAc;IACd,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,OAAO;IACP,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;EACpB;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,mCAAmC;AACnC;;GAEG;;AAEH;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,sCAAsC;EACtC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,iCAAiC;EACjC,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kCAAkC;EAClC,YAAY;AACd;AACA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,kDAAkD;AACpD;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,kBAAkB;EACpB;;AAEF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kCAAkC;IAClC,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* NorstellaCoverageFinder styles */\r\n\r\n:host {\r\n  all: initial;\r\n}\r\n\r\n.norstella-cf-coverageFinder {\r\n  text-align: left;\r\n}\r\n\r\n.norstella-cf-loaderTable {\r\n  position: absolute;\r\n  z-index: 3;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  margin: auto;\r\n  width: 60px;\r\n  height: 60px;\r\n}\r\n\r\n.norstella-cf-MuiInputBase-input {\r\n  height: 0.9175em;\r\n}\r\n\r\n.norstella-cf-searchButton {\r\n  border-radius: 6px;\r\n  padding: 8px 16px;\r\n  text-transform: capitalize;\r\n  height: 40px;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: 150%;\r\n  align-self: end;\r\n  /* 24px */\r\n}\r\n\r\n.norstella-cf-MuiButton-startIcon {\r\n  margin-right: 0px;\r\n}\r\n\r\n.norstella-cf-coverageFinderBox {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  padding: max(10px, 1vw);\r\n  color: #000;\r\n}\r\n\r\n.norstella-cf-flexAlignCenterRow {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-direction: row;\r\n}\r\n\r\n.norstella-cf-flexAlignStartRow {\r\n  display: flex;\r\n  align-items: start;\r\n  flex-direction: row;\r\n}\r\n\r\n.norstella-cf-prescriberCustomNoteDialog {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: 10px;\r\n}\r\n\r\n.norstella-cf-paFormDialog {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: 10px;\r\n}\r\n\r\n.norstella-cf-popupPAForm {\r\n  width: 250px;\r\n}\r\n\r\n.norstella-cf-paFormOkBtn {\r\n  width: 50px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.norstella-cf-div-row {\r\n  display: flex;\r\n  flex-direction: row;\r\n  width: 100%;\r\n}\r\n\r\n.norstella-cf-div-col {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n}\r\n\r\n.norstella-cf-searchLabel {\r\n  width: 100%;\r\n}\r\n\r\n.norstella-cf-lblLocation {\r\n  font-weight: bold;\r\n  padding-bottom: 3px;\r\n}\r\n\r\n.norstella-cf-lblIndication {\r\n  font-weight: bold;\r\n  padding-bottom: 3px;\r\n}\r\n\r\n.norstella-cf-indicationDiv {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.norstella-cf-indicationDDLDiv {\r\n  width: 100%;\r\n}\r\n\r\n\r\n.norstella-cf-lblProduct {\r\n  font-weight: bold;\r\n  padding-bottom: 3px;\r\n}\r\n\r\n.norstella-cf-productDiv {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.norstella-cf-productDDLDiv {\r\n  width: 100%;\r\n}\r\n\r\n.norstella-cf-lblNPI {\r\n  font-weight: bold;\r\n  padding-bottom: 3px;\r\n}\r\n\r\n.norstella-cf-lblFilterCriteria {\r\n  font-weight: bold;\r\n  padding-bottom: 3px;\r\n}\r\n\r\n.norstella-cf-filterdiv {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  position: relative;\r\n}\r\n\r\n.norstella-cf-header {\r\n  font-family: \"Poppins Bold\", Arial, Helvetica, sans-serif;\r\n}\r\n\r\n.norstella-cf-SortIcon {\r\n  height: 20px;\r\n  width: 20px;\r\n  margin-left: 5px;\r\n}\r\n\r\n/* Desktop Only Styles */\r\n@media screen and (min-width: 1033px) {\r\n  .norstella-cf-benefitTypeButtonGroup {\r\n    width: 200px;\r\n  }\r\n\r\n  .norstella-cf-searchComponents {\r\n    flex-direction: row;\r\n    align-items: center;\r\n    position: relative;\r\n  }\r\n\r\n  .norstella-cf-message {\r\n    margin-top: 0px;\r\n    position: absolute;\r\n    left: \"0\";\r\n    top: 100%;\r\n    margin-left: 0px;\r\n  }\r\n\r\n  .norstella-cf-productDDLDiv {\r\n    position: relative;\r\n  }\r\n\r\n  .norstella-cf-productDDLDiv .norstella-cf-message {\r\n    top: 40px;\r\n  }\r\n\r\n  .norstella-cf-noPlanCardMessage {\r\n    margin-top: 20px;\r\n    position: relative;\r\n    width: 100%;\r\n    margin-left: 50%;\r\n    color: red;\r\n  }\r\n\r\n  .norstella-cf-searchButton {\r\n    margin-left: 7px;\r\n    text-transform: capitalize;\r\n  }\r\n\r\n  .norstella-cf-patientsearchButton {\r\n    border-radius: 6px;\r\n    padding: 8px 16px;\r\n    height: 40px;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-size: 16px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: 150%;\r\n    align-self: end;\r\n    margin-left: 25px;\r\n    text-transform: capitalize;\r\n  }\r\n\r\n  .norstella-cf-PatientGridContainerSubHeaderDualBenefit {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n  }\r\n\r\n  .norstella-cf-PatientGridItemSubHeader {\r\n    flex-grow: 1;\r\n  }\r\n\r\n  .norstella-cf-PatientGridItemDualBenefit {\r\n    margin-left: auto;\r\n  }\r\n\r\n  .norstella-cf-divSearchCoverage {\r\n    width: 50%;\r\n  }\r\n\r\n  .norstella-cf-flexAlignResponsive {\r\n    display: flex;\r\n    align-items: center;\r\n    flex-direction: row;\r\n  }\r\n\r\n  .norstella-cf-flexAlignFilterBar {\r\n    display: flex;\r\n    align-items: end;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    padding-left: 16px;\r\n    padding-right: 16px;\r\n  }\r\n\r\n  .norstella-cf-leftMargin {\r\n    margin-left: 25px;\r\n  }\r\n\r\n  .norstella-cf-bottomMargin {\r\n    margin-bottom: 0px;\r\n  }\r\n\r\n  .norstella-cf-rightMargin {\r\n    margin-right: 10px;\r\n  }\r\n\r\n  .norstella-cf-MuiAutocomplete-root {\r\n    width: 300px;\r\n    min-width: 200px;\r\n  }\r\n\r\n  .norstella-cf-searchText {\r\n    min-width: 200px;\r\n  }\r\n\r\n  .norstella-cf-searchComponents .norstella-cf-MuiAutocomplete-option.Mui-focused {\r\n    font-weight: bold;\r\n    background-color: #949494;\r\n  }\r\n\r\n  .norstella-cf-MuiAutocomplete-root .norstella-cf-MuiOutlinedInput-root .norstella-cf-MuiAutocomplete-input::placeholder {\r\n    color: #595959 !important;\r\n    opacity: 1 !important;\r\n  }\r\n\r\n  .norstella-cf-MuiInputBase-input::placeholder {\r\n    color: #595959 !important;\r\n    opacity: 1 !important;\r\n  }\r\n\r\n  .norstella-cf-ProductText {\r\n    min-width: 200px;\r\n  }\r\n\r\n  .norstella-cf-npiSearch {\r\n    min-width: 170px;\r\n  }\r\n\r\n  .norstella-cf-npierrormessage {\r\n    min-width: 170px;\r\n  }\r\n\r\n  .norstella-cf-filtererrormessage {\r\n    min-width: 170px;\r\n    margin-left: 30px;\r\n  }\r\n\r\n  .norstella-cf-searchPlans {\r\n    width: 30%;\r\n    min-width: 150px;\r\n    margin-right: 2px;\r\n    height: 42px;\r\n    min-height: 42px;\r\n  }\r\n\r\n  /* .norstella-cf-divSearchResults {\r\n    width: 30%;\r\n    display: inline-grid;\r\n  } */\r\n\r\n  .norstella-cf-header {\r\n    font-size: 20px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: 120%;\r\n  }\r\n\r\n  .norstella-cf-MuiToggleButtonGroup-grouped {\r\n    padding-top: 8px;\r\n    padding-bottom: 8px;\r\n    padding-left: 8px;\r\n    padding-right: 8px;\r\n    line-height: 20px;\r\n  }\r\n\r\n  .norstella-cf-notedetails {\r\n    font-size: 16px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: 130%;\r\n    text-align: center;\r\n  }\r\n\r\n  .norstella-cf-statement {\r\n    font-weight: bold;\r\n    white-space: initial;\r\n  }\r\n\r\n  .norstella-cf-MuiGrid-root.norstella-cf-MuiGrid-item.statementDualBenefitMuiGridItem {\r\n    padding-top: 0px;\r\n  }\r\n\r\n  .norstella-cf-headerSubHeader {\r\n    font-size: 18px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: 130%;\r\n    white-space: initial;\r\n    margin-top: 7px;\r\n  }\r\n\r\n  .norstella-cf-hidden {\r\n    visibility: hidden;\r\n  }\r\n\r\n  .norstella-cf-geoSearchHidden {\r\n    height: 20px;\r\n    min-width: 200px;\r\n  }\r\n\r\n  .norstella-cf-coverage-content {\r\n    border-bottom: 4px solid #000;\r\n  }\r\n\r\n  .norstella-cf-prescriberNoteHeader {\r\n    padding-left: 16px;\r\n    padding-right: 16px;\r\n  }\r\n\r\n  .norstella-cf-filterdiv {\r\n    margin-left: 20px;\r\n  }\r\n\r\n  .norstella-cf-MuiAutocomplete-root .norstella-cf-MuiOutlinedInput-root .norstella-cf-MuiAutocomplete-input {\r\n    padding: 3px 4px 3px 5px;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 1185px) {\r\n  .norstella-cf-searchPlans {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n/* Mobile Styles */\r\n@media screen and (max-width: 1032px) {\r\n  .norstella-cf-PatientGridContainerSubHeaderDualBenefit {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .norstella-cf-PatientGridItemDualBenefit {\r\n    margin-left: 0;\r\n  }\r\n\r\n  .norstella-cf-searchComponents {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    position: relative;\r\n  }\r\n\r\n  .norstella-cf-message {\r\n    margin-top: 5px;\r\n    position: static;\r\n    left: \"0\";\r\n    top: 100%;\r\n    margin-left: 0px;\r\n  }\r\n\r\n  .norstella-npi-message {\r\n    margin-left: 55%;\r\n  }\r\n\r\n  .norstella-cf-noPlanCardMessage {\r\n    margin-top: 20px;\r\n    position: relative;\r\n    width: 100%;\r\n    margin-left: 35%;\r\n    color: red;\r\n  }\r\n\r\n  .norstella-cf-searchButton {\r\n    margin-left: 0px;\r\n    margin-top: 15px;\r\n    margin-bottom: 20px;\r\n    width: 98%;\r\n    text-transform: capitalize;\r\n  }\r\n\r\n  .norstella-cf-patientsearchButton {\r\n    margin-top: 10px;\r\n    width: 94%;\r\n    text-transform: capitalize;\r\n  }\r\n\r\n  .norstella-cf-sortButton {\r\n    text-transform: capitalize;\r\n    background-color: rgb(0, 88, 111);\r\n    margin-right: 7px;\r\n    height: 44px;\r\n    padding: 0px;\r\n  }\r\n\r\n  .norstella-cf-searchContainer {\r\n    display: flex;\r\n    gap: 10px;\r\n    width: 100%;\r\n  }\r\n\r\n  .norstella-cf-sortButton:hover {\r\n    background-color: rgb(0, 88, 111);\r\n  }\r\n\r\n  .norstella-cf-sortCard {\r\n    border: none;\r\n  }\r\n\r\n  /* Target odd cards */\r\n  .norstella-cf-mobileCardView .norstella-cf-card:nth-child(odd) {\r\n    background-color: #ffffff;\r\n  }\r\n\r\n  /* Target even cards */\r\n  .norstella-cf-mobileCardView .norstella-cf-card:nth-child(even) {\r\n    background-color: #eff6f9;\r\n  }\r\n\r\n  .norstella-cf-divSearchCoverage {\r\n    width: 100%;\r\n  }\r\n\r\n  .norstella-cf-filterdiv {\r\n    width: 100%;\r\n  }\r\n\r\n  .norstella-cf-flexAlignResponsive {\r\n    display: flex;\r\n    align-items: space-between;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .norstella-cf-leftMargin {\r\n    margin-left: 0px;\r\n  }\r\n\r\n  .norstella-cf-bottomMargin {\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .norstella-cf-rightMargin {\r\n    margin-right: 0px;\r\n  }\r\n\r\n  .norstella-cf-channelDiv {\r\n    margin-bottom: 20px;\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n\r\n  .norstella-cf-MuiAutocomplete-root {\r\n    width: 98%;\r\n    height: 44px;\r\n  }\r\n\r\n  .norstella-cf-MuiInputBase-root {\r\n    height: 44px;\r\n  }\r\n\r\n  .norstella-cf-channelLabel {\r\n    font-weight: bold;\r\n    padding-bottom: 3px;\r\n    display: flex;\r\n    justify-content: left;\r\n  }\r\n\r\n  .norstella-cf-searchPlans {\r\n    display: flex;\r\n    align-items: center;\r\n    flex-grow: 1;\r\n  }\r\n\r\n  .norstella-cf-searchPlansInput {\r\n    width: 100%;\r\n  }\r\n\r\n  .norstella-cf-MuiGrid-root.norstella-cf-MuiGrid-item {\r\n    padding-top: 0px;\r\n  }\r\n\r\n  .norstella-cf-MuiGrid-root.norstella-cf-MuiGrid-item.header {\r\n    font-size: larger;\r\n    font-weight: bold;\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n  }\r\n\r\n  .norstella-cf-coverage-content {\r\n    margin-top: 20px;\r\n    border-top: 1px solid #000;\r\n    border-top-width: thick;\r\n    padding-top: 10px;\r\n  }\r\n\r\n  .norstella-cf-notedetails {\r\n    font-size: 10px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: 130%;\r\n  }\r\n\r\n  .norstella-cf-coverageFilterAndTable {\r\n    margin-left: 4%;\r\n  }\r\n\r\n  .norstella-cf-header {\r\n    line-height: 120%;\r\n    white-space: initial;\r\n    margin-top: 20px;\r\n    margin-bottom: 11px;\r\n  }\r\n\r\n  .norstella-cf-headerSubHeader {\r\n    font-weight: bold;\r\n    white-space: initial;\r\n    margin-top: 7px;\r\n    margin-bottom: 11px;\r\n  }\r\n\r\n  #geoSearch {\r\n    min-height: 0;\r\n  }\r\n\r\n  #npiSearch {\r\n    min-height: 0;\r\n  }\r\n\r\n  .norstella-cf-prescriberNoteHeader {\r\n    padding-left: 16px;\r\n    padding-right: 16px;\r\n  }\r\n\r\n  .norstella-cf-footer {\r\n    margin-top: 10px;\r\n  }\r\n\r\n  .norstella-cf-verticalNoteValue {\r\n    display: inline;\r\n    margin-left: 3px;\r\n  }\r\n\r\n  .norstella-cf-divPAFormDialogOuter {\r\n    display: inline;\r\n  }\r\n\r\n  .norstella-cf-sectionFieldDash {\r\n    margin-left: 5px;\r\n  }\r\n\r\n  .norstella-cf-customValue {\r\n    display: inline;\r\n  }\r\n\r\n  .norstella-cf-MuiAutocomplete-root .norstella-cf-MuiOutlinedInput-root .norstella-cf-MuiAutocomplete-input {\r\n    padding: 7.5px 4px 7.5px 5px;\r\n  }\r\n\r\n  .norstella-cf-MuiAutocomplete-root .norstella-cf-MuiAutocomplete-inputRoot {\r\n    padding-top: 0px;\r\n    padding-bottom: 0px;\r\n  }\r\n}\r\n\r\n/* Media Query from 1200 to 1032 stacking search bar and buttons */\r\n@media screen and (max-width: 1200px) {\r\n  .norstella-cf-flexAlignFilterBar {\r\n    display: block !important;\r\n    text-align: center;\r\n  }\r\n\r\n  .norstella-cf-searchPlans {\r\n    margin-bottom: 5px !important;\r\n  }\r\n\r\n  .norstella-cf-divChannelButtonGroup {\r\n    padding-bottom: 5px;\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n\r\n  /* Lowering percentage statement font size to fit screen width */\r\n  .norstella-cf-dynamicStatement {\r\n    font-size: 21px !important;\r\n  }\r\n}\r\n\r\n@media (max-width: 1023px) {\r\n  .norstella-cf-benefitTypeButtonGroup {\r\n    width: 100%;\r\n    display: flex;\r\n    margin-left: 0;\r\n    justify-content: center;\r\n    padding-top: 3px;\r\n  }\r\n\r\n  .norstella-cf-benefitTypeButtonGroup button {\r\n    width: 50%;\r\n    flex: 1;\r\n    border-radius: 4px;\r\n  }\r\n\r\n  .norstella-cf-benefitLabel {\r\n    font-weight: bold;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .norstella-cf-statement {\r\n    font-weight: bold;\r\n    white-space: initial;\r\n    margin-bottom: 6px;\r\n  }\r\n}\r\n\r\n.norstella-cf-prescriberNoteSectionName {\r\n  display: block;\r\n  font-size: 1.5em;\r\n  margin-block-start: 0.83em;\r\n  margin-block-end: 0.83em;\r\n  margin-inline-start: 0px;\r\n  margin-inline-end: 0px;\r\n  font-weight: bold;\r\n}\r\n\r\n/* Remove this if changing styles */\r\n/* .geoSearchInput {\r\n    padding: 0px;\r\n} */\r\n\r\n.norstella-cf-displayCoverageLayoutGridItem {\r\n  padding-top: 3px;\r\n  padding-left: 16px;\r\n  padding-right: 16px;\r\n}\r\n\r\n.norstella-cf-searchSeparator {\r\n  margin-left: 10px;\r\n  margin-right: 10px;\r\n}\r\n\r\n.norstella-cf-benefitTypeDiv {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin-left: auto;\r\n  float: right;\r\n  position: relative;\r\n}\r\n\r\n.norstella-cf-benefitTypeButtonGroup {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.norstella-cf-benefitTypeButtonGroup button {\r\n  width: 50%;\r\n  flex: 1;\r\n  border-radius: 4px;\r\n}\r\n\r\n.norstella-cf-benefitLabel {\r\n  font-weight: bold;\r\n  padding-bottom: 3px;\r\n}\r\n\r\n.norstella-cf-benefitTypeButton {\r\n  text-transform: capitalize;\r\n}\r\n\r\n.norstella-cf-message {\r\n  color: #b50505;\r\n}\r\n\r\n.norstella-cf-message-error {\r\n  color: #b50505;\r\n}\r\n\r\n.norstella-cf-autocomplete-custom-close {\r\n  padding: 0px !important;\r\n}\r\n\r\n.norstella-cf-patientInsuranceType .norstella-cf-MuiInputBase-root {\r\n  padding-right: 14px !important;\r\n}\r\n\r\n.norstella-cf-patientBenefitType .norstella-cf-MuiInputBase-root {\r\n  padding-right: 14px !important;\r\n}\r\n\r\n.norstella-cf-patientGeoSearch .norstella-cf-MuiInputBase-root {\r\n  padding-right: 14px !important;\r\n}\r\n\r\n#norstella-cf-geoSearch .norstella-cf-MuiAutocomplete-inputRoot {\r\n  padding-right: 9px;\r\n}\r\n\r\n.norstella-cf-resultmessage {\r\n  color: #000;\r\n  text-align: center;\r\n  font-weight: bold;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.norstella-cf-noresultmessage {\r\n  display: flex;\r\n  justify-content: center;\r\n  /* Center horizontally */\r\n  align-items: center;\r\n  /* Center vertically */\r\n  width: 100%;\r\n  /* Ensure the span takes full width */\r\n  height: 100%;\r\n  /* Ensure the span takes full height */\r\n  font-weight: bold;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.norstella-cf-channelButtonGroup .norstella-cf-channelButton {\r\n  text-wrap: nowrap;\r\n  font-size: min(18px, max(14px, 0.8vw));\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: 150%;\r\n  height: 42px;\r\n  min-height: 42px;\r\n}\r\n\r\n.norstella-cf-MuiTouchRipple-rippleVisible {\r\n  opacity: 0.2 !important;\r\n}\r\n\r\n.norstella-cf-divChannelButtonGroup {\r\n  height: 42px;\r\n  min-height: 42px;\r\n}\r\n\r\n/* Table */\r\n.norstella-cf-MuiTable-root.norstella-cf-MuiTable-stickyHeader {\r\n  table-layout: fixed;\r\n}\r\n\r\n.norstella-cf-coverageTableContainer {\r\n  border-radius: 3px;\r\n  overflow-y: scroll !important;\r\n}\r\n\r\n.norstella-cf-prescriberNoteContainer {\r\n  border-radius: 3px;\r\n}\r\n\r\n.norstella-cf-tableHeaderRow {\r\n  background-color: #bebebe;\r\n}\r\n\r\n#coverageTableContainer:focus-visible {\r\n  outline: solid !important;\r\n}\r\n\r\n.norstella-cf-focusHeadRow .norstella-cf-focusCellData:focus-visible {\r\n  outline: solid;\r\n}\r\n\r\n.norstella-cf-MuiTableSortLabel-root:hover .norstella-cf-MuiTableSortLabel-icon {\r\n  color: #0E575D;\r\n  opacity: 1;\r\n}\r\n\r\n.norstella-cf-MuiTableSortLabel-root.Mui-active .norstella-cf-MuiTableSortLabel-icon {\r\n  color: #4F4F4F;\r\n}\r\n\r\n.norstella-cf-tableHeaderCell {\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  min-width: 20%;\r\n  line-height: 20px;\r\n  text-wrap: wrap;\r\n  top: auto;\r\n}\r\n\r\n.norstella-cf-tableDataCell {\r\n  font-size: 13px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 20px;\r\n}\r\n\r\n.norstella-cf-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgb(0 0 0 / 89%);\r\n  /* Semi-transparent black color */\r\n  z-index: 999;\r\n  /* Ensure the overlay is above other content */\r\n}\r\n\r\n.norstella-cf-tableHeaderRow th:last-child {\r\n  border-right: 0;\r\n}\r\n\r\n.norstella-cf-verticalTableContainer label {\r\n  font-weight: bold;\r\n}\r\n\r\n.norstella-cf-verticalTableContainer th:last-child {\r\n  border: 0;\r\n}\r\n\r\n.norstella-cf-verticalTableContainer td:last-child {\r\n  border: 0;\r\n}\r\n\r\n.norstella-cf-tableHeaderCellPlanName {\r\n  width: 50%;\r\n  text-wrap: balance;\r\n}\r\n\r\n.norstella-cf-tableHeaderCellPlanNamePAR {\r\n  text-wrap: balance;\r\n}\r\n\r\n.norstella-cf-tableHeaderCellPrescriberNotes {\r\n  min-width: 150px;\r\n}\r\n\r\n.norstella-cf-tableSortLabel>svg {\r\n  height: 20px;\r\n  width: 20px;\r\n  margin-left: 5px;\r\n}\r\n\r\n.norstella-cf-mobilePlanHeader {\r\n  display: block;\r\n  font-size: 20px;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: 130%;\r\n  margin-top: 0px;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.norstella-cf-mobilePlanDetails {\r\n  font-size: 13px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 20px;\r\n}\r\n\r\n.norstella-cf-tableNotesDiv {\r\n  width: 100%;\r\n}\r\n\r\n.norstella-cf-tableHeaderCellIcon {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n}\r\n\r\n.norstella-cf-tableRowCellIcon {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  font-size: 25px;\r\n}\r\n\r\n.norstella-cf-DynamicColCellIcon {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  height: 20px;\r\n  width: 20px;\r\n  cursor: pointer;\r\n}\r\n\r\n.norstella-cf-DynamicColCellIconBefore {\r\n  margin-right: 5px;\r\n}\r\n\r\n.norstella-cf-DefaultLoadingIcon {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  height: 40px;\r\n  width: 40px;\r\n  cursor: pointer;\r\n  animation: spin 1s linear infinite;\r\n  margin: auto;\r\n}\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n.norstella-cf-displayPrefix {\r\n  margin-right: 5px;\r\n}\r\n\r\n.norstella-cf-PAFormIcon {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  height: 20px;\r\n  width: 20px;\r\n}\r\n\r\n.norstella-cf-spansContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.norstella-cf-mobilePlanDetailsContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.norstella-cf-tableRowCellNoteText {\r\n  vertical-align: 0px;\r\n  text-decoration: underline;\r\n  font-size: 13px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 20px;\r\n  color: #18766d;\r\n}\r\n\r\n.norstella-cf-tableColHidden {\r\n  display: none;\r\n}\r\n\r\n.norstella-cf-card {\r\n  margin-top: 10px;\r\n}\r\n\r\n.norstella-cf-footer {\r\n  text-align: left;\r\n}\r\n\r\n.norstella-cf-customFooter {\r\n  font-size: smaller;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.norstella-cf-planCardDetails {\r\n  font-size: smaller;\r\n  margin-bottom: 15px;\r\n  width: 100%;\r\n}\r\n\r\n.norstella-cf-patientDiv {\r\n  display: flex;\r\n  flex-direction: row;\r\n  width: 100%;\r\n}\r\n\r\n.norstella-cf-topMargin {\r\n  margin-top: 20px;\r\n}\r\n\r\n.norstella-cf-patientSearchInfoIcon {\r\n  margin-right: 5px;\r\n  height: 0.9em;\r\n  font-size: 1rem;\r\n  color: #58c3b9;\r\n}\r\n\r\n.norstella-cf-dynamicStatement {\r\n  font-size: larger;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.norstella-cf-headerSubHeaderText {\r\n  font-size: larger;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.norstella-cf-footerText {\r\n  font-weight: bold;\r\n  font-size: smaller;\r\n}\r\n\r\n.norstella-cf-trademark {\r\n  margin-top: 15px;\r\n  font-size: smaller;\r\n}\r\n\r\n.norstella-cf-footnoteText {\r\n  font-size: x-small;\r\n}\r\n\r\n.norstella-cf-mobileCardView {\r\n  max-height: 650px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.norstella-cf-mobileCardView.disable-scroll {\r\n  overflow-y: hidden !important;\r\n  /* Remove scrolling on mobile when popup is open */\r\n}\r\n\r\n.norstella-cf-MuiDataGrid-root .norstella-cf-MuiDataGrid-cell {\r\n  white-space: normal !important;\r\n  word-wrap: break-word !important;\r\n}\r\n\r\n.norstella-cf-MuiDataGrid-columnHeaderTitle {\r\n  font-weight: bold !important;\r\n}\r\n\r\n.norstella-cf-MuiInputBase-input {\r\n  padding: 13px 14px;\r\n}\r\n\r\n.norstella-cf-MuiNativeSelect-root {\r\n  width: 98%;\r\n  border-radius: 4px;\r\n  border: 1px solid #303030;\r\n}\r\n\r\n.norstella-cf-MuiNativeSelect-select {\r\n  height: 1.3em;\r\n}\r\n\r\n.norstella-cf-prescriberNoteCardContent {\r\n  padding: 10px;\r\n  border-radius: 8px;\r\n  border: 1px solid #303030;\r\n}\r\n\r\n.norstella-cf-additionalNoteDiv {\r\n  border-top: thick solid rgb(0, 0, 0);\r\n}\r\n\r\n.norstella-cf-coverageTableContainer tr:nth-child(odd) {\r\n  background-color: #ffffff;\r\n}\r\n\r\n/* Styles for odd rows */\r\n.norstella-cf-coverageTableContainer tr:nth-child(even) {\r\n  background-color: #eff6f9;\r\n}\r\n\r\n.norstella-cf-prescriberNoteContainer tr:nth-child(odd) {\r\n  background-color: #ffffff;\r\n}\r\n\r\n/* Styles for odd rows */\r\n.norstella-cf-prescriberNoteContainer tr:nth-child(even) {\r\n  background-color: #eff6f9;\r\n}\r\n\r\n/* Styles for even rows */\r\n.norstella-cf-verticalTableContainer tr:nth-child(even) {\r\n  background-color: #ffffff;\r\n}\r\n\r\n/* Styles for odd rows */\r\n.norstella-cf-verticalTableContainer tr:nth-child(odd) {\r\n  background-color: #eff6f9;\r\n}\r\n\r\n.norstella-cf-prescriberNoteSection {\r\n  font-size: 20px;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: 130%;\r\n  /* 26px */\r\n}\r\n\r\n.norstella-cf-tableNoteBodyCell {\r\n  font-size: 13px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 20px;\r\n  overflow-wrap: break-word;\r\n}\r\n\r\n.norstella-cf-verticalTableNoteCellTitle {\r\n  font-size: 13px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 20px;\r\n  overflow-wrap: break-word;\r\n  width: 30%;\r\n}\r\n\r\n.norstella-cf-noteWithoutSectionContent {\r\n  padding-bottom: 0px;\r\n}\r\n\r\n.norstella-cf-verticalTableNoteCellContent {\r\n  font-size: 13px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 20px;\r\n  overflow-wrap: break-word;\r\n  width: 70%;\r\n}\r\n\r\n.norstella-cf-verticalNoteTable {\r\n  table-layout: fixed;\r\n}\r\n\r\n.norstella-cf-MuiCardContent-root:empty {\r\n  display: none;\r\n}\r\n\r\n.norstella-cf-MuiCard-root {\r\n  box-shadow: none;\r\n}\r\n\r\n.norstella-cf-lineNoteTitle {\r\n  font-weight: bold;\r\n}\r\n\r\n.norstella-cf-dataSource {\r\n  color: red;\r\n}\r\n\r\n.norstella-cf-spnCustomValueDash {\r\n  color: black;\r\n}\r\n\r\n.norstella-cf-notificationCard {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  background-color: #0E173E;\r\n  color: white;\r\n  padding: 16px;\r\n  /* Equivalent to padding: 2 */\r\n  border-radius: 16px;\r\n  /* Equivalent to borderRadius: 2 */\r\n  width: 100%;\r\n}\r\n\r\n.norstella-cf-notificationBox {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-grow: 1;\r\n}\r\n\r\n.norstella-cf-notificationMessage {\r\n  margin-right: 16px;\r\n  /* Equivalent to marginRight: 2 */\r\n}\r\n\r\n.norstella-cf-button {\r\n  background-color: #45D7C4;\r\n  color: #0E173E;\r\n  text-transform: none;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .norstella-cf-PatientColDiv {\r\n    margin-right: 20px;\r\n  }\r\n\r\n}\r\n\r\n.norstella-cf-visiblehidden-aria-label {\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 1px;\r\n  overflow: hidden;\r\n  clip: rect(0, 0, 0, 0);\r\n  white-space: nowrap;\r\n  border: 0;\r\n}\r\n\r\n/* Disable scrolling */\r\n.no-scroll {\r\n  overflow: hidden;\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n  touch-action: none;\r\n  /* Prevents touch scrolling */\r\n}\r\n\r\n@media (max-width:330px) {\r\n  .norstella-cf-displayCoverageLayoutGridItem {\r\n    padding-left: 0px;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .norstella-cf-mobileCardView::-webkit-scrollbar {\r\n    width: 1px;\r\n  }\r\n\r\n  .norstella-cf-mobileCardView::-webkit-scrollbar-thumb {\r\n    scrollbar-color: rgb(0, 0, 0, 0.2);\r\n    border-radius: 4px;\r\n  }\r\n\r\n  .norstella-cf-displayCoverageCardContent {\r\n    padding: 8px !important;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
